import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  layoutModeTypes,
  layoutWidthTypes,
  layoutPositionTypes,
  topbarThemeTypes,
  sidebarSizeTypes,
  sidebarVisibilityTypes,
} from '../../config';

interface LayoutState {
  layoutMode: string;
  layoutWidth: string;
  layoutPosition: string;
  topbarTheme: string;
  sidebarSize: string;
  sidebarVisibility: string;
  sidebarOpen: boolean;
}

const initialState: LayoutState = {
  layoutMode: layoutModeTypes.LIGHTMODE,
  layoutWidth: layoutWidthTypes.FLUID,
  layoutPosition: layoutPositionTypes.FIXED,
  topbarTheme: topbarThemeTypes.LIGHT,
  sidebarSize: sidebarSizeTypes.DEFAULT,
  sidebarVisibility: sidebarVisibilityTypes.SHOW,
  sidebarOpen: true,
};

const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    changeLayoutMode: (state, action: PayloadAction<string>) => {
      state.layoutMode = action.payload;
    },
    changeSidebarSize: (state, action: PayloadAction<string>) => {
      state.sidebarSize = action.payload;
    },
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.sidebarOpen = action.payload;
    },
  },
});

export const { changeLayoutMode, changeSidebarSize, toggleSidebar, setSidebarOpen } = layoutSlice.actions;
export default layoutSlice.reducer;
